import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { LeadRequest, LeadResponse } from '../../models/lead.model';

@Injectable({
  providedIn: 'root'
})
export class LeadManagementService {
  private apiUrl = environment.leadsApiUrl;

  constructor(private http: HttpClient) {}

  submitLead(leadData: LeadRequest): Observable<LeadResponse> {
    return this.http.post<LeadResponse>(this.apiUrl, leadData);
  }
}
